import { mods } from '@approvalmax/theme';
import { Flex } from '@approvalmax/ui/src/components';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { font } from '../../../../../../modules/styles';
import { CurrencyDisclaimerLegacy } from '../../../../components/(legacy)/CurrencyDisclaimerLegacy/CurrencyDisclaimerLegacy';

export const Root = styled(Flex)`
    margin-top: 20px;
    padding: 0 60px;
`;

export const FooterLeft = styled.div`
    flex: 1;
`;
export const FooterLines = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-end;
`;

export const FooterTotalLine = styled.div`
    ${font(13, '#000000', 'bold')}
`;

export const StyledCurrencyDisclaimer = styled(CurrencyDisclaimerLegacy)`
    ${font(11, '#6c6a6a')}
`;

export const ReorderableContent = styled(Flex)<StyledMods<{ ordered: boolean; applyTaxAfterDiscount: boolean }>>`
    ${mods('ordered', true)`
        ${mods('applyTaxAfterDiscount', false)`
            & > :nth-child(1) {
                order: 1;
            }
        `}

        ${mods('applyTaxAfterDiscount', true)`
            & > :nth-child(1) {
                order: -1;
            }
        `}

        & > :nth-child(2) {
                order: 2;
            }
    `}
`;
